import type { Department } from '../../types/Department'

export default [
	{
		name: 'Email Sorting Company',
		basePrice: 15,
		baseDebtPerSecond: 1,
		priceMultiplier: 1.17,
		description:
			'Modern problems require modern solutions. The email sorting company helps give your least important emails high priority.',
		sublime: true
	},
	{
		name: 'Speech Writing Mill',
		basePrice: 1_000,
		priceMultiplier: 1.15,
		baseDebtPerSecond: 8,
		description:
			'Your team of writers will craft speeches that will ensure the lowest approval ratings possible.'
	},
	{
		name: 'Cold Call Center',
		basePrice: 100_000,
		baseDebtPerSecond: 80,
		description:
			'A small office of interns awkwardly reading scripted calls to voters.'
	},
	{
		name: 'Poll Analysis Lab',
		basePrice: 1_500_000,
		baseDebtPerSecond: 600,
		description:
			'A modest team cherry-picking favorable polls to pretend everything is fine.'
	},
	{
		name: 'Focus Groups',
		basePrice: 20_000_000,
		baseDebtPerSecond: 4_500,
		description:
			'Overpriced gatherings of actors pretending to provide genuine feedback.'
	},
	{
		name: 'Merchandise Factory',
		basePrice: 250_000_000,
		baseDebtPerSecond: 35_000,
		description:
			'Produces campaign merch like collectible buttons and luxury pantsuits, with factories in North Korea.'
	},
	{
		name: 'Super PACs',
		basePrice: 3_000_000_000,
		baseDebtPerSecond: 250_000,
		description:
			'Organizations that collect and misspend questionable campaign donations from wealthy donors.'
	},
	{
		name: 'Prediction Market',
		basePrice: 35_000_000_000,
		baseDebtPerSecond: 1_800_000,
		description:
			'An online platform where donors bet on campaign outcomes, with the house always losing for a change.'
	},
	{
		name: 'Celebrity Booking Agency',
		basePrice: 400_000_000_000,
		baseDebtPerSecond: 12_500_000,
		description:
			'Coordinates high-profile endorsements but often accidentally hires lookalikes.'
	},
	{
		name: 'Luxury Conference Rooms',
		basePrice: 5_000_000_000_000,
		baseDebtPerSecond: 85_000_000,
		description:
			'Lavish meeting spaces rented to lobbyists for overpriced strategy sessions.'
	},
	{
		name: 'Private Security',
		basePrice: 60_000_000_000_000,
		baseDebtPerSecond: 600_000_000,
		description:
			'Hires security personnel for events. Thanks to their expertise, there have only been 6 major acts of terrorism at your rallies.'
	},
	{
		name: 'Social Media Bot Farm',
		basePrice: 750_000_000_000_000,
		baseDebtPerSecond: 4_200_000_000,
		description:
			'A digital operation generating fake followers and promoting hashtags, though they tend to post error messages instead.'
	},
	{
		name: 'Fake News Network',
		basePrice: 9_000_000_000_000_000,
		baseDebtPerSecond: 30_000_000_000,
		description:
			'Produces low-budget propaganda and fabricated scandals to confuse the public.'
	},
	{
		name: 'Data Mining Firm',
		basePrice: 100_000_000_000_000_000,
		baseDebtPerSecond: 210_000_000_000,
		description:
			"A tech company analyzing supporter data to uncover trends and patterns, but only for people that can't read, it seems."
	},
	{
		name: 'Election Machines',
		basePrice: 1_200_000_000_000_000_000,
		baseDebtPerSecond: 1_500_000_000_000,
		description:
			'Voting machines designed for convenience. Some mysterious bugs have put them into public disrepute.'
	},
	{
		name: 'Espionage Academy',
		basePrice: 15_000_000_000_000_000_000,
		baseDebtPerSecond: 10_500_000_000_000,
		description:
			'An extensive training school for spies to infiltrate rival campaigns. Thanks to this, it takes about four minutes for them to get discovered instead of two.'
	},
	{
		name: 'Smuggling Network',
		basePrice: 180_000_000_000_000_000_000,
		baseDebtPerSecond: 73_500_000_000_000,
		description:
			'A secretive logistics network transporting sensitive campaign materials, often misplacing them.'
	},
	{
		name: 'Diplomacy Syndicate',
		basePrice: 2_100_000_000_000_000_000_000,
		baseDebtPerSecond: 510_000_000_000_000,
		description:
			'A global operation influencing foreign governments and policies for campaign losses.'
	},
	{
		name: 'Branding Group',
		basePrice: 25_000_000_000_000_000_000_000,
		baseDebtPerSecond: 3_500_000_000_000_000,
		description:
			'Rebrands entire nations with campaign-friendly names and slogans, unreciprocated by its subjects.'
	},
	{
		name: 'Deep State Ventures',
		basePrice: 300_000_000_000_000_000_000_000,
		baseDebtPerSecond: 24_500_000_000_000_000,
		description: 'A clandestine network manipulating world events.'
	},
	{
		name: 'Climate Control Corporation',
		basePrice: 3_500_000_000_000_000_000_000_000,
		baseDebtPerSecond: 170_000_000_000_000_000,
		description:
			"Claims to control weather for the right mood during campaign rallies. It's not clear why the right weather is apparently hurricanes, but anything is better than nothing."
	},
	{
		name: 'Campaign Theme Parks',
		basePrice: 42_000_000_000_000_000_000_000_000,
		baseDebtPerSecond: 1_200_000_000_000_000_000,
		description:
			"Massive amusement parks celebrating the campaign, with attractions like 'Email Server Spin.'"
	},
	{
		name: 'Interstellar Advertising',
		basePrice: 500_000_000_000_000_000_000_000_000,
		baseDebtPerSecond: 8_400_000_000_000_000_000,
		description:
			"Broadcasts campaign ads beyond Earth's atmosphere, so that Mars knows how poor a candidate you are as well."
	}
] as Department[]

enum DepartmentIds {
	'Email Sorting Company',
	'Speech Writing Mill',
	'Cold Call Center',
	'Poll Analysis Lab',
	'Focus Groups',
	'Merchandise Factory',
	'Super PACs',
	'Prediction Market',
	'Celebrity Booking Agency',
	'Luxury Conference Rooms',
	'Private Security',
	'Social Media Bot Farm',
	'Fake News Network',
	'Data Mining Firm',
	'Election Machines',
	'Espionage Academy',
	'Smuggling Network',
	'Diplomacy Syndicate',
	'Branding Group',
	'Deep State Ventures',
	'Climate Control Corporation',
	'Campaign Theme Parks',
	'Interstellar Advertising'
}
export { DepartmentIds }
